import { reactive, type VNode } from 'vue'

interface ToastItem {
  id: number
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
}

const state = reactive({
  toasts: [] as ToastItem[],
})

let _id = 0

export function useToast() {
  function addToast(message: string, type: ToastItem['type'] = 'info', duration = 3000) {
    const id = ++_id
    state.toasts.push({ id, message, type })
    setTimeout(() => {
      const el = document.getElementById(`toast-${id}`)
      if (el) {
        el.style.opacity = '0'
        el.style.transition = 'opacity 0.3s'
        setTimeout(() => {
          state.toasts = state.toasts.filter(t => t.id !== id)
        }, 300)
      }
    }, duration)
  }

  function toast(message: string, type: ToastItem['type'] = 'info', duration?: number) {
    addToast(message, type, duration)
  }

  return { toasts: state.toasts, toast }
}

/** 全局 toast 函数（供非组件代码调用） */
let _globalToast: ((msg: string, type?: string, duration?: number) => void) | null = null
export function setGlobalToast(fn: typeof _globalToast) { _globalToast = fn }
export function globalToast(msg: string, type: string = 'info', duration?: number) {
  _globalToast?.(msg, type, duration)
}
